




















































































































import PostCodeField from '@/components/fields/PostCodeField.vue';
import { BaseStepForm } from '@/components/forms/onboarding/BaseStepForm';
import { IODUserForm } from '@/model';
import { Nullable } from '@homeserve/od-typings/utils';
import { Component, Emit } from 'vue-property-decorator';
import { State } from 'vuex-class';

@Component({
  components: {
    PostCodeField,
  },
})
export default class UserForm extends BaseStepForm<IODUserForm> {
  @State('userAuthenticated', { namespace: 'auth' })
  public readonly isAuthenticated!: boolean;

  public readonly formScope = 'userForm';
  public showPassword = false;

  @Emit('change')
  public updateLastName(lastName: Nullable<string>): IODUserForm {
    return {
      ...this.model,
      lastName: lastName ? lastName.toUpperCase() : '',
    };
  }

  @Emit('change')
  public updatePhone(phone: Nullable<string>): IODUserForm {
    return {
      ...this.model,
      phone: phone ? phone.replace(/\s/g, '') : '',
    };
  }

  @Emit('change')
  public updateFirstName(firstName: Nullable<string>): IODUserForm {
    return {
      ...this.model,
      firstName: firstName
        ? firstName
            .toLowerCase()
            .split('-')
            .map(s => s.charAt(0).toUpperCase() + s.substring(1))
            .join('-')
        : '',
    };
  }
}
